/* istanbul ignore file */

/* eslint-disable camelcase */
import {
    COOKIE_GA4_SERVER_SIDE_EVENTS,
    COOKIE_SERVER_SIDE_EVENTS,
    EVENTS,
} from './tracking';
import {
    eraseCookie, getCookieDomain,
} from './cookie';
import {
    useAuth,
} from '../stores/user-store';
import {
    getTrackingStats,
} from '../services/tracking';
import * as logger from './logger';

export function makeGA4Tracker() {
    if (typeof window.dataLayer !== 'object') {
        window.dataLayer = window.dataLayer || [];
    }

    return {
        enable(gtm) {
            // Loading of GTM could be blocked (e.g., by an ad blocker).
            if (!gtm) return;

            gtm.enable(true);
        },
        event({
            event = 'click_element',
            element = null,
            elementDetail = null,
            jobId = null,
            method = null,
            isServerSide = false,
            isServerSideGa4 = false,
            user_data = null,
        }) {
            window.dataLayer.push({
                event,
                element,
                element_detail: elementDetail,
                job_id: jobId,
                method,
                user_data,
            });
            // Erase serverside cookies after pushing to the dataLayer
            if (isServerSideGa4) eraseCookie(COOKIE_GA4_SERVER_SIDE_EVENTS, getCookieDomain());
            if (isServerSide) eraseCookie(COOKIE_SERVER_SIDE_EVENTS, getCookieDomain());
        },
        trackVisibility({ element = null, elementDetail = null }) {
            if (process.env.NODE_ENV === 'development' && element === null) {
                // eslint-disable-next-line no-console
                console.warn('No element for GA4 visibility tracking defined');
            }
            window.dataLayer.push({
                event: EVENTS.trackVisibility,
                element,
                // eslint-disable-next-line camelcase
                element_detail: elementDetail,
            });
        },
        async trackUser() {
            try {
                const auth = useAuth();
                const userUuid = auth.uuid;
                const userType = userUuid ? 'user' : 'guest';
                const tracking = userUuid ? await getTrackingStats() : null;

                window.dataLayer.push({
                    ...tracking,
                    event: EVENTS.userData,
                    userType,
                    userId: userUuid,
                });
            } catch (exception) {
                /* istanbul ignore next */
                logger.warning({
                    exception,
                    message: 'Failed to track user data.',
                });
            }
        },
        trackPageView(pageUrl) {
            window.dataLayer.push({
                event: EVENTS.pageView,
                pageTitle: document.title,
                pageUrl,
            });
        },
        trackSubContentGroup(group) {
            window.dataLayer.push({
                content_group_detail: group,
            });
        },
    };
}
/* eslint-enable camelcase */
